import {
  EntityList,
  EntityListProps,
  renderPersona,
} from 'components/EntityList'
import { Department } from 'gql.generated'
import { ConstrainMode, PersonaSize } from 'office-ui-fabric-react'
import { SelectionMode } from 'office-ui-fabric-react/lib/MarqueeSelection'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type DepartmentListProps = EntityListProps<Department>

export const DepartmentList: React.FC<DepartmentListProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])

  const columns = React.useMemo(
    () => [
      fieldColumn('department', { minWidth: 75 }),
      fieldColumn('headOfDepartment', {
        onRender: renderPersona({ size: PersonaSize.size8 }),
      }),
    ],
    [fieldColumn]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.single}
      constrainMode={ConstrainMode.horizontalConstrained}
      items={items}
      columns={columns}
      {...props}
    />
  )
}
